import { useEffect } from "react";
import { connect } from "react-redux";
import { styled, makeStyles } from "@mui/styles";
import Loader from "../Loader";
import { format } from "date-fns";
import { spacing } from "@mui/system";
import { primaryCategories, statuses } from "./dynamicsConstants";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/reducers/knowledgeReducer";
import { grey } from "@mui/material/colors";
import DatePickerControl from "../../helpers/DatePickerControl";
import {
    Typography,
    Card as MuiCard,
    CardContent,
    Grid,
    Button as MuiIconButton,
    CircularProgress,
    Box,
    FormControl,
    MenuItem,
    Select
} from "@mui/material";
import {
    Edit as EditIcon,
    Replay as UndoIcon
} from "@mui/icons-material";

const IconButton = styled(MuiIconButton)({
    padding: '2px',
    marginTop: '-2px',
    marginLeft: '2px',
    minWidth: 0,
    color: grey[700]
});

const Card = styled(MuiCard)(spacing);

const useStyles = makeStyles((theme) => ({
    gridContainer: {
        margin: theme.spacing(4, 4),
    },
    gridItem: {
        paddingRight: theme.spacing(4),
    },
}));

const KnowledgeArticleDetailsCard = ({ knowledgeState, updateArticle, article, setModeField }) => {
    const { categories } = knowledgeState;

    const classes = useStyles();
    const mode = knowledgeState.modeFields.articleDetails;

    useEffect(() => {
        setModeField("articleDetails", "view");
    }, [setModeField]);

    const handleChange = async (e) => {

        let field = e.target.name;
        let value = e.target.value;

        let newArticle = { ...article, [field]: value }
        updateArticle(newArticle, field, "articleDetails");        
    };

    const handleDateChange = async (field, date) => {
        let newArticle = { ...article, [field]: date }
        updateArticle(newArticle, field, "articleDetails");        
    };

    const articleReviewDate = article.reviewDate ? new Date(article.reviewDate) : null;
    const articleNextReviewDate = article.nextReviewDate ? new Date(article.nextReviewDate) : null;
    
    if (!article)
        return <Loader />;

    const articleDetails = {
        "Review Date": mode === "edit"
            ? (
                <DatePickerControl
                    style={{ marginTop: "-8px" }}
                    value={articleReviewDate}
                    onChange={(date) => handleDateChange('reviewDate', date)}
                />
            )
            : article.reviewDate && format(articleReviewDate, "dd/MM/yyyy"),
        "Next Review Date": mode === "edit"
            ? (
                <DatePickerControl
                    style={{ marginTop: "-8px" }}
                    value={articleNextReviewDate}
                    onChange={(date) => handleDateChange('nextReviewDate', date)}
                />
            )
            : article.nextReviewDate && format(articleNextReviewDate, "dd/MM/yyyy"),
        "Article Status":
            mode === "edit"
                ? (
                    <FormControl style={{ marginTop: "-8px" }}>
                        <Select
                            name="articleStatus"
                            value={article.articleStatus}
                            onChange={handleChange}
                            style={{ width: "150px" }}
                        >
                            {Object.keys(statuses)
                                .map((status) => (
                                    <MenuItem
                                        key={status}
                                        value={status}
                                    >
                                        {statuses[status]}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                )
                : statuses[article.articleStatus],
        "Primary Category":
            mode === "edit"
                ? (
                    <FormControl style={{ marginTop: "-8px" }}>
                        <Select
                            name="primaryCategory"
                            value={article.primaryCategory}
                            onChange={handleChange}
                            style={{ width: "150px" }}
                        >
                            {Object.keys(primaryCategories)
                                .map((categoryId) => (
                                    <MenuItem
                                        key={categoryId}
                                        value={categoryId}
                                    >
                                        {primaryCategories[categoryId]}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                )
                : primaryCategories[article.primaryCategory],
        "Sub Category":
            mode === "edit"
                ? (
                    <FormControl style={{ marginTop: "-8px" }}>
                        <Select
                            name="categoryId"
                            value={article.categoryId}
                            onChange={handleChange}
                            style={{ width: "150px" }}
                        >
                            {Object.keys(categories)
                                .map((categoryId) => (
                                    <MenuItem
                                        key={categoryId}
                                        value={categoryId}
                                    >
                                        {categories[categoryId]}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                )
                : categories[article.categoryId]
    }

    return (
        (<Card mb={6}>
            <CardContent>
                <Box display="flex">
                    <Box flexGrow={1} alignItems="center">
                        <Typography variant="h6" gutterBottom>Details</Typography>
                    </Box>
                    <Box>
                        {
                            mode === "view" && (
                                <IconButton onClick={() => setModeField("articleDetails", "edit")} size="large">
                                    <EditIcon />
                                </IconButton>
                            )}
                        {
                            mode === "edit" && (
                                <IconButton onClick={() => setModeField("articleDetails", "view")} size="large">
                                    <UndoIcon />
                                </IconButton>
                            )}
                        {
                            mode === "saving" && (
                                <CircularProgress
                                    size={21}
                                    style={{ marginLeft: "9px" }}
                                />
                            )}
                    </Box>
                </Box>
                {
                    Object.keys(articleDetails).map((key, index) => (
                        <Grid key={index} container className={classes.gridContainer}>
                            <Grid item xs={6} md={12} lg={5} className={classes.gridItem}>
                                <Typography variant="body2">{key}</Typography>
                            </Grid>
                            <Grid item xs={6} md={12} lg={7} className={classes.gridItem}>
                                <Typography variant="subtitle2">{articleDetails[key]}</Typography>
                            </Grid>
                        </Grid>
                    ))
                }
            </CardContent>
        </Card>)
    );
};

const mapStateToProps = (state) => ({
    knowledgeState: state.knowledgeReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeArticleDetailsCard);
